import React from 'react';
import {Input} from '../UI';
import {MaskedInput} from '../UI/MaskedInput';

export const ContractorInfo = () => {
  return (
    <div className='space-y-4'>
      <div className='grid grid-cols-2 gap-6'>
        <Input name='name' label="Name of IC's business" />
        <Input name='type' label='Type of business (Sole proprietorship, crop, etc.)' />
      </div>
      <div className='grid grid-cols-3 gap-6'>
        <MaskedInput name='phone' label='Phone Number' mask='(999) 999-9999' />
        <MaskedInput name='fax' label='Fax' mask='(999) 999-9999' />
        <Input name='email' label='E-mail' />
      </div>
    </div>
  );
};